import { useCallback, useState } from 'react';
import { useGetDownloadUrl } from '@/shared/hooks/useGetDownloadUrl';

export function useProfileImageSection(photoAssetId: string | null) {
  const { downloadUrl, isLoading: isLoadingUrl } = useGetDownloadUrl(photoAssetId ?? undefined);

  const [isHovered, setIsHovered] = useState(false);

  const handleDownload = useCallback(() => {
    if (!downloadUrl) return;
    // eslint-disable-next-line @typescript-eslint/no-deprecated -- standard DOM API for programmatic downloads
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'persona-profile-image';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, [downloadUrl]);

  return { downloadUrl, isLoadingUrl, isHovered, setIsHovered, handleDownload };
}
